import React from "react";
import { RiDraggable } from 'react-icons/ri';

export function renderDragIcon(style = {}, variant = "inline") {
  const baseStyle = {
    cursor: "grab",
    fontSize: "18px",
    color: "#888",
    display: "flex",
    alignItems: "center",
  };

  const variantStyles = {
    inline: { marginLeft: "8px", flexShrink: 0 },
    absolute: { position: "absolute", right: "5px", top: "20px", zIndex: 1 },
  };

  return (
    <span className="drag-icon" style={{ ...baseStyle, ...variantStyles[variant], ...style }}>
      <RiDraggable />
    </span>
  );
}
